import { t } from '@lingui/core/macro'

export enum ModeType {
  GRID = 'grid',
  LIST = 'list'
}

export const CONST_ROOT_FOLDER = 'BIBLIOTECA_VIRTUAL!TECSINAPSE!'
export const CONST_ROOT_NAME = t`Biblioteca`

export const VisibilidadePasta = {
  PUBLICA: { label: 'Pública', value: true },
  PRIVADA: { label: 'Privada', value: false }
} as const

export const maxSize = 10000000000

export const initialFilters = [
  {
    dataCriacao: new Date(),
    nome: '',
    proprietario: {
      email: ''
    },
    pastaPai: {
      nome: ''
    }
  }
]
export const NEW_ITEM_MAX_DAYS = 7
